
import { TabDirective } from 'ngx-bootstrap/tabs';
import { ShowRequest } from './show-request';


export class AppTab {
  setSelected: (bSelected:boolean) => void = (bSelected) => {}
  hasUnsavedData: () => boolean = ()=>false
  active: boolean = false
  closable: boolean = false
  disabled: boolean = false
  viewInfo: ShowRequest
  close : () => void = ()=>{}
  remove : ( te : TabDirective ) => void
  url : string // for bookmarking in browser
}
